module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imgcenter"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "id": "img11_4",
      "src": "images/img11_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Men in New York searched the lists daily. 8US")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Dubbed ‘America’s biggest lottery’. A blindfolded Secretary of State in Washington drew out a number, and every man in the 4,577 selective draft districts in the United States holding that particular number was the first man drawn to the colours in his district. As the numbers were drawn lists were posted throughout the country.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e530b5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/01n_AMERICAN_EXPEDITIONARY_FORCE.vue
// module id = 111
// module chunks = 0